module.exports = __webpack_public_path__ + "static/media/trash-outline.da0d3673.svg";